import { DeleteFilled, PlusCircleFilled } from '@ant-design/icons'
import { FormNumberInput } from '@components/_SiteWide/Form/FormNumberInput'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Form, Popconfirm } from 'antd'
import React from 'react'

import { CurrencyInput } from './CurrencyInput'

export function MileageRows({ rates, isEditing = false, selectedRow, formattedCurrency }) {
  return (
    <Form.List name='rates'>
      {(fields, { add, remove }) => {
        return (
          <Vertical className='full-height-width'>
            <Horizontal
              bg='elevated'
              className='border-bottom px-3 mt-2 pb-1'
              style={{ minHeight: '25px', maxHeight: '25px' }}
            >
              <Vertical flex={1}>
                <Texto>Distance From</Texto>
              </Vertical>
              <Vertical flex={1}>
                <Texto>Distance To</Texto>
              </Vertical>
              <Vertical flex={1}>
                <Texto>Rate (per {selectedRow?.unit.substring(0, selectedRow.unit.length - 1)})</Texto>
              </Vertical>
              <Vertical flex={0.25} verticalCenter alignItems='flex-end'>
                {isEditing ? (
                  <PlusCircleFilled
                    onClick={() => add()}
                    className='ant-btn ant-btn-sm add-bol ghost-gravi-button mr-1'
                  />
                ) : (
                  ''
                )}
              </Vertical>
            </Horizontal>
            <div style={{ overflowY: 'auto' }}>
              {fields.map((field, index) => (
                <Horizontal
                  key={index}
                  flex={1}
                  className='border-bottom px-3 mt-2 pb-1'
                  style={{ minHeight: '25px', maxHeight: '25px' }}
                >
                  <Vertical flex={1}>
                    {/** @ts-ignore | FormNumberInput can't be used as a JSX component? */}
                    <FormNumberInput
                      initialValue={rates[index] ? rates[index].distance_from : null}
                      editable={isEditing}
                      name={[index, 'distance_from']}
                      message='Distance From is required'
                      width='90%'
                      required
                    />
                  </Vertical>
                  <Vertical flex={1}>
                    {/** @ts-ignore | FormNumberInput can't be used as a JSX component? */}
                    <FormNumberInput
                      initialValue={rates[index] ? rates[index].distance_to : null}
                      editable={isEditing}
                      name={[index, 'distance_to']}
                      width='90%'
                      required={false}
                    />
                  </Vertical>
                  <Vertical flex={1}>
                    <CurrencyInput
                      initialValue={rates[index] && rates[index].rate ? rates[index].rate.toFixed(5) : ''}
                      editable={isEditing}
                      name={[index, 'rate']}
                      message='Rate is required'
                      width='90%'
                      required
                      formattedCurrency={formattedCurrency}
                    />
                  </Vertical>
                  <Vertical flex={0.25} verticalCenter alignItems='flex-end'>
                    {isEditing ? (
                      <Popconfirm
                        title='Are you sure you want to delete this rate?'
                        onConfirm={(e) => remove(index)}
                        okText='Yes'
                        cancelText='No'
                      >
                        <GraviButton icon={<DeleteFilled />} error appearance='link' />
                      </Popconfirm>
                    ) : (
                      ''
                    )}
                  </Vertical>
                </Horizontal>
              ))}
            </div>
          </Vertical>
        )
      }}
    </Form.List>
  )
}
